<div class="upload-media">
  <div class="upload-media__container">
    <div class="upload-media__header">
      <div class="upload-media__title">{{ 'app.components.courseCreator.settings.uploadMedia.title' | translate }}</div>
    </div>

    <div class="upload-media__card">
      <div class="upload-media__content">
        <div class="upload-media__section">
          <div class="upload-media__section-title">
            <div class="upload-media__title-text">
              {{ 'app.components.courseCreator.settings.uploadMedia.description' | translate }}
            </div>
          </div>
        </div>

        <div
          class="upload-media__dropzone"
          [class.uploading]="isUploading()"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
        >
          @if (isUploading()) {
            <div class="upload-media__upload-progress">
              <div class="upload-media__loader">
                <div class="upload-media__spinner"></div>
              </div>
              <div class="upload-media__progress-text">
                <span class="upload-media__progress-percentage">{{ uploadProgress() }}%</span>
                <span class="upload-media__progress-label">{{ 'app.components.courseCreator.settings.uploadMedia.uploading' | translate }}</span>
              </div>
              <div class="upload-media__progress-bar">
                <div class="upload-media__progress-bar-fill" [style.width.%]="uploadProgress()"></div>
              </div>
            </div>
          } @else {
            <div class="upload-media__dropzone-icon">
              <img src="/public/svgs/upload.svg" alt="Upload" />
            </div>

            <button
              type="button"
              class="upload-media__device-button"
              (click)="fileInput.click()"
            >
              <div class="upload-media__device-button-content">
                <span class="upload-media__device-button-text">{{ 'app.components.courseCreator.settings.uploadMedia.fromDevice' | translate }}</span>
                <div class="upload-media__device-button-arrow">
                  <img src="/public/svgs/chevron-down.svg" alt="Arrow Right" />
                </div>
              </div>
            </button>

            <input
              #fileInput
              type="file"
              multiple
              accept=".jpg,.png,.svg,.zip"
              class="upload-media__file-input"
              (change)="onFileSelect($event)"
            />

            <div class="upload-media__dropzone-text">
              <div class="upload-media__text-row">
                <span class="upload-media__text-normal">{{ 'app.components.courseCreator.settings.uploadMedia.dragYourFiles' | translate }}</span>
                <span class="upload-media__text-normal">{{ 'app.components.courseCreator.settings.uploadMedia.browse' | translate }}</span>
              </div>
              <div class="upload-media__text-hint">
                {{ 'app.components.courseCreator.settings.uploadMedia.maxFiles' | translate }}<br />
                {{ 'app.components.courseCreator.settings.uploadMedia.allowedFormats' | translate }}
              </div>
            </div>
          }
        </div>

        @if (uploadedFiles().length > 0) {
          <div class="upload-media__previews">
            @for (metadata of fileMetadata(); track metadata.file.name + metadata.file.size) {
              <div class="upload-media__preview-item">
                <div class="upload-media__preview-content">
                  @if (metadata.isImage) {
                    <img
                      class="upload-media__preview-thumbnail"
                      [src]="metadata.thumbnail"
                      [alt]="metadata.file.name"
                      (error)="onImageError($event)"
                    />
                  } @else {
                    <div class="upload-media__preview-file-icon">
                      <div class="upload-media__file-icon-box">
                        <div class="upload-media__file-icon-extension-box">
                          <div class="upload-media__file-icon-extension">{{ metadata.extension }}</div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="upload-media__preview-info">
                    <div class="upload-media__preview-name">{{ metadata.file.name }}</div>
                    <div class="upload-media__preview-size">{{ metadata.size }}</div>
                  </div>
                  <button
                    type="button"
                    class="upload-media__preview-remove"
                    (click)="removeFileByFile(metadata.file)"
                    [attr.aria-label]="'app.components.courseCreator.settings.uploadMedia.removeFile' | translate"
                  >
                    <img src="/public/svgs/trash.svg" alt="Remove" />
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
